import React, { useState } from 'react';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import RotateRight from '@material-ui/icons/RotateRight';
import RotateLeft from '@material-ui/icons/RotateLeft';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';

const styles = theme => ({
  paper: {
    maxWidth: 936,
    margin: 'auto',
    overflow: 'hidden',
  },
  searchBar: {
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
  },
  searchInput: {
    fontSize: theme.typography.fontSize,
  },
  block: {
    display: 'block',
  },
  addUser: {
    marginRight: theme.spacing(1),
  },
  contentWrapper: {
    margin: '40px 16px',
  },
  input: {
    display: 'none',
  },
  button: {
    margin: theme.spacing(1),
  },
  rightIcon: {
    marginLeft: theme.spacing(1),
  },
});

class Content extends React.Component {
  constructor(props) {
    super(props);
    this.imageCanvas = React.createRef();
    this.decompressedCanvas = React.createRef();
  }

  render() {
    const { classes } = this.props;
    let RgbQuant = require('rgbquant');
    let Canvas = require('canvas');

    let replaceImageDataRGB = (imageData, orginal, replace) => {
      for (var i = 0; i < imageData.data.length; i += 4) {
        // is this pixel the old rgb?
        if (imageData.data[i] == orginal[0] &&
          imageData.data[i + 1] == orginal[1] &&
          imageData.data[i + 2] == orginal[2]
        ) {
          // change to your new rgb
          imageData.data[i] = replace[0];
          imageData.data[i + 1] = replace[1];
          imageData.data[i + 2] = replace[2];
        }
      }
      return imageData;
    }

    let replaceImageData = (imageData, o_palette, n_palette) => {
      let colorDifference = (color1, color2) => {
        var sumOfSquares = 0;

        sumOfSquares += Math.pow(color1[0] - color2[0], 2);
        sumOfSquares += Math.pow(color1[1] - color2[1], 2);
        sumOfSquares += Math.pow(color1[2] - color2[2], 2);

        return Math.sqrt(sumOfSquares);
      }

      console.log(n_palette);

      for (let i = 0; i < 4; i++) {
        let closest_color = n_palette[0];
        let closest_distance = 99999;
        for (let j = 0; j < 4; j++) {
          let distance = colorDifference(o_palette[i], n_palette[j][1]);
          if (distance < closest_distance) {
            closest_color = n_palette[j][0];
            closest_distance = distance;
          }
        }
        replaceImageDataRGB(imageData, o_palette[i], closest_color);
      }

      return imageData;
    }

    let createNeutroniumPalette = (gData) => {
      let landscape_colors = {
        clouds: [[105, 105, 105], [200, 200, 240]],
        fog: [[119, 186, 29], [190, 190, 200]],
        hill: [[126, 200, 100], [90, 120, 60]],
        mountain: [[134, 150, 100], [40, 40, 40]],
        river: [[147, 100, 200], [50, 120, 190]],
        rock: [[149, 100, 50], [30, 30, 30]],
        sea: [[154, 198, 218], [130, 140, 190]],
        sky: [[156, 238, 221], [150, 150, 190]],
        snow: [[158, 158, 170], [240, 240, 240]],
        stone: [[161, 161, 100], [60, 60, 60]],
        water: [[177, 200, 255], [130, 130, 190]]
      };
      let plant_colors = {
        bush: [[96, 110, 50], [130, 160, 180]],
        flower: [[118, 0, 0], [130, 200, 0]],
        grass: [[123, 200, 0], [90, 120, 60]],
        straw: [[162, 163, 235], [200, 200, 0]],
        tree: [[168, 200, 50], [70, 120, 60]],
        wood: [[181, 123, 0], [90, 120, 60]]
      };

      let palette = [];
      for (let i = 0; i < 8; i++) {
        switch (gData.responses[0].labelAnnotations[i].description) {
          case 'Sky': palette = [landscape_colors.sky, landscape_colors.clouds, landscape_colors.sky, landscape_colors.clouds]; break;
          case 'Nature': palette = [landscape_colors.sky, landscape_colors.hill, landscape_colors.sea, landscape_colors.clouds]; break;
          case 'Mountain': palette = [landscape_colors.sky, landscape_colors.hill, landscape_colors.clouds, landscape_colors.mountain]; break;
        }
      }

      return palette;
    }

    let generateNeutronium = (imageRaw, gData) => {
      console.log(gData);
      let image = new Image();
      // console.log(image);

      let opts = {
        colors: 4,             // desired palette size
        method: 2,               // histogram method, 2: min-population threshold within subregions; 1: global top-population
        boxSize: [64, 64],        // subregion dims (if method = 2)
        boxPxls: 2,              // min-population threshold (if method = 2)
        initColors: 4096,        // # of top-occurring colors  to start with (if method = 1)
        minHueCols: 0,           // # of colors per hue group to evaluate regardless of counts, to retain low-count hues
        dithKern: null,          // dithering kernel name, see available kernels in docs below
        dithDelta: 0,            // dithering threshhold (0-1) e.g: 0.05 will not dither colors with <= 5% difference
        dithSerp: false,         // enable serpentine pattern dithering
        palette: [],             // a predefined palette to start with in r,g,b tuple format: [[r,g,b],[r,g,b]...]
        reIndex: false,          // affects predefined palettes only. if true, allows compacting of sparsed palette once target palette size is reached. also enables palette sorting.
        useCache: true,          // enables caching for perf usually, but can reduce perf in some cases, like pre-def palettes
        cacheFreq: 10,           // min color occurance count needed to qualify for caching
        colorDist: "euclidean",  // method used to determine color distance, can also be "manhattan"
      };

      let canvas = this.imageCanvas.current;
      const ctx = canvas.getContext("2d");
      image.onload = function () {
        ctx.drawImage(image, 0, 0, 512, 512);

        let q = new RgbQuant(opts);
        q.sample(canvas);
        let pal = q.palette(true);
        let out = q.reduce(canvas);

        console.log(pal);

        let array = new Uint8ClampedArray(out);
        let out_idata = new ImageData(array, 512, 512);

        let resultantData = replaceImageData(out_idata, pal, createNeutroniumPalette(gData));

        ctx.putImageData(out_idata, 0, 0);
      }
      image.src = imageRaw;
    }

    async function getGoogleVision(imageEncoded) {
      const request = {
        'requests': [
          {
            'image': {
              'content': imageEncoded.substring(imageEncoded.indexOf(',') + 1, imageEncoded.length)
            },
            "features": [
              {
                "maxResults": 8,
                "type": "OBJECT_LOCALIZATION"
              },
              {
                "maxResults": 8,
                "type": "LABEL_DETECTION"
              },
            ],
          }
        ]
      };
      const response = await fetch('https://vision.googleapis.com/v1/images:annotate?key=AIzaSyAuyMPQxRVN2zq2HB6q-shY22rF_nCf784', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(request),
      });
      generateNeutronium(imageEncoded, (await response.json()));
    }

    let loadImage = (e) => {
      let reader = new FileReader();
      reader.readAsDataURL(e[0]);
      reader.onload = (e) => {
        getGoogleVision(e.target.result);
      }
    }

    // let loadNeutronium = (e) => {
    //   let reader = new FileReader();
    //   reader.readAsDataURL(e[0]);
    //   reader.onload = (e) => {
    //     getGoogleVision(e.target.result);
    //   }
    // }

    return (
      <React.Fragment>
        <Paper className={classes.paper}>
          <AppBar className={classes.searchBar} position="static" color="default" elevation={0}>
            <Toolbar>
              <Grid container spacing={2} alignItems="center">
                <Grid item>
                  <RotateRight className={classes.block} color="inherit" />
                </Grid>
                <Grid item xs>
                  <h2>Encode your image</h2>
                </Grid>
                <Grid item>
                  <input
                    accept="image/*"
                    className={classes.input}
                    onChange={(e) => loadImage(e.target.files)}
                    id="uploaded-image"
                    multiple
                    type="file"
                  />
                  <label htmlFor="uploaded-image">
                    <Button variant="contained" color="primary" component="span" type="submit">
                      Upload
        <CloudUploadIcon className={classes.rightIcon} />
                    </Button>
                  </label>
                </Grid>
              </Grid>
            </Toolbar>
          </AppBar>
          <div className={classes.contentWrapper}>
            <canvas ref={this.imageCanvas} width={512} height={512} />
          </div>
        </Paper>
        {/* <br />
        <Paper className={classes.paper}>
          <AppBar className={classes.searchBar} position="static" color="default" elevation={0}>
            <Toolbar>
              <Grid container spacing={2} alignItems="center">
                <Grid item>
                  <RotateLeft className={classes.block} color="inherit" />
                </Grid>
                <Grid item xs>
                  <h2>Decode your image</h2>
                </Grid>
                <Grid item>
                  <input
                    accept="image/*"
                    className={classes.input}
                    onChange={(e) => loadNeutronium(e.target.files)}
                    id="uploaded-image"
                    multiple
                    type="file"
                  />
                  <label htmlFor="uploaded-image">
                    <Button variant="contained" color="primary" component="span" type="submit">
                      Upload
        <CloudUploadIcon className={classes.rightIcon} />
                    </Button>
                  </label>
                </Grid>
              </Grid>
            </Toolbar>
          </AppBar>
          <div className={classes.contentWrapper}>
            <canvas ref={this.decompressedCanvas} width={512} height={512} />
          </div>
        </Paper> */}
      </React.Fragment>
    );
  }
}

Content.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Content);
